<template>
    <!-- Add New / Edit Invoice: right-pinned house modal (60–90% height, body scrolls, footer pinned) -->
    <div id="addInvoiceItemModal" ref="addInvoiceItemModal" class="modal fade fxModal" tabindex="-1" aria-hidden="true"
        data-bs-backdrop="static" data-bs-keyboard="false">
        <div
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content">
                <div class="modal-body !p-3 !pb-0 font-roboto flex flex-col">
                    <FxModalHeader :title="`${isEdit ? 'Edit' : 'Add New'} Invoice`" @close="hide()" />
                    <div class="flex-1 flex flex-col gap-[12px] px-[6px]">
                        <div>
                            <label class="uqcLabel">Total Amount</label>
                            <div class="flex items-center h-[40px] rounded-[8px] overflow-hidden border-1 border-[#E1E5EF]">
                                <span
                                    class="w-[40px] h-full flex-shrink-0 flex items-center justify-center text-[16px] text-white bg-[#7695FF]">$</span>
                                <input v-model="invoiceForm.total" type="number" placeholder="0.00"
                                    class="w-full h-full px-[12px] border-0 outline-none text-[14px] text-[#333333] placeholder:text-[#AAAAAA] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none">
                            </div>
                        </div>
                        <div class="flex items-center justify-between gap-[10px]">
                            <span class="text-[15px] font-medium text-[#333333]">Items</span>
                            <button type="button"
                                class="flex items-center gap-[6px] h-[32px] px-[12px] rounded-full border-1 border-[#00B7C2] bg-[#fff] text-[13px] text-[#00B7C2] hover:!bg-[#00B7C2] hover:text-white transition"
                                @click="addItem">
                                <svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                    <path d="M7 1.5v11M1.5 7h11" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                Add Items
                            </button>
                        </div>
                        <div v-if="invoiceForm?.items?.length" ref="itemList" class="flex flex-col gap-[10px]">
                            <div v-for="(item, index) in invoiceForm.items" :key="index"
                                class="p-[12px] rounded-[10px] border-1 border-[#EFEFEF] bg-white">
                                <div class="flex items-center justify-between gap-[10px] mb-[4px]">
                                    <label class="uqcLabel !m-0">Item Name</label>
                                    <button type="button" aria-label="Delete item"
                                        class="w-[26px] h-[26px] p-0 rounded-full flex items-center justify-center border !border-[#EFEFEF] text-[#F67280] !bg-[#fff] hover:text-[#fff] hover:!bg-[#F67280]"
                                        @click="removeItem(index)">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-[13px] h-[13px]" aria-hidden="true">
                                            <path fill="currentColor" fill-rule="evenodd"
                                                d="M9.774 5L3.758 3.94l.174-.986a.5.5 0 0 1 .58-.405L18.411 5h.088h-.087l1.855.327a.5.5 0 0 1 .406.58l-.174.984l-2.09-.368l-.8 13.594A2 2 0 0 1 15.615 22H8.386a2 2 0 0 1-1.997-1.883L5.59 6.5h12.69zH5.5zM9 9l.5 9H11l-.4-9zm4.5 0l-.5 9h1.5l.5-9zm-2.646-7.871l3.94.694a.5.5 0 0 1 .405.58l-.174.984l-4.924-.868l.174-.985a.5.5 0 0 1 .58-.405z" />
                                        </svg>
                                    </button>
                                </div>
                                <input v-model="item.name" type="text" placeholder="Enter Item Name"
                                    class="w-full h-[40px] px-[12px] rounded-[8px] border-1 outline-none text-[14px] text-[#333333] placeholder:text-[#AAAAAA]"
                                    :class="item.error ? 'border-[#EE5851]' : 'border-[#E1E5EF]'" @input="item.error = false">
                                <p v-if="item.error" class="m-0 mt-[4px] text-[12px] text-[#EE5851]">Please Fill the Field</p>
                            </div>
                        </div>
                        <div v-else
                            class="flex items-center justify-center min-h-[150px] rounded-[10px] border-1 border-dashed border-[#CCCCCC] bg-[#EFEFEF80]">
                            <p class="m-0 text-[14px] text-[#666666]">No Items Available</p>
                        </div>
                    </div>
                    <div class="uqcFooter flex items-center justify-end gap-[10px]">
                        <button type="button" class="uqcBtnCancel" @click="hide()">Cancel</button>
                        <button type="button" class="uqcBtnNext disabled:!bg-[#CCCCCC] disabled:!border-[#CCCCCC] disabled:!cursor-not-allowed"
                            :disabled="isSaveDisabled" @click="saveInvoice">
                            {{ isEdit ? 'Update' : 'Save' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import { Modal } from "bootstrap";
import { disableScroll } from "@/helpers/scrollHelper";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    components: { FxModalHeader },
    data() {
        return {
            modal: null,
            itemError: '',
            invoiceForm: {
                job_type: 'sar',
                job_id: this.$route.params.id,
                source: 'manual',
                total: 0
            },
            isEdit: false,
            source: '',
        };
    },

    computed: {
        ...mapGetters(["invoiceItem", "invoiceItemError", "invoiceItemList", "invoiceList"]),
        isSaveDisabled() {
            return (
                !this.invoiceForm?.total ||
                this.invoiceForm?.items?.length === 0 ||
                this.invoiceForm?.items?.some(item => !item.name?.trim())
            );
        }
    },

    watch: {
        invoiceItemError: function () {
            if (this.invoiceItemError.length <= 0) {
                return
            }
            // keep the modal open with the server message; reset so the same message shows again (QA D-35)
            this.itemError = this.invoiceItemError
            toast.error(this.itemError)
            this.updateInvoiceItemError()
        },
        invoiceItemList: function () {
            if (this.source == 'create' || this.source == 'edit') {
                this.invoiceForm['items'] = this.invoiceItemList
                disableScroll();
                this.modal?.show();
            }
        }
    },

    methods: {
        ...mapActions(["addInvoiceItem", "getInvoiceItem", "updateInvoiceItemError"]),

        show(source, val) {
            delete this.invoiceForm["items"]
            delete this.invoiceForm["invoice_id"]
           // delete this.invoiceForm['total']
            this.isEdit = false
            this.source = source
           

            this.invoiceForm['source'] = source
            if (this.invoiceForm.source == 'edit') {
                this.invoiceForm['invoice_id'] = val.id
                this.invoiceForm['total'] = val.amount
                this.isEdit = true
            }
            else{
                this.invoiceForm['total'] = val.remaining
            }
            this.getInvoiceItem(this.invoiceForm)
            if (!this.modal) {
                this.modal = new Modal(this.$refs.addInvoiceItemModal, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
        },

        hide() {
            this.source = ''
            this.modal?.hide();
        },

        addItem() {
            const emptyIndex = this.invoiceForm.items.findIndex(
                item => !item.name?.trim()
            );

            // Clear previous errors
            this.invoiceForm.items.forEach(item => {
                item.error = false;
            });

            if (emptyIndex !== -1) {
                this.invoiceForm.items[emptyIndex].error = true;
                return;
            }

            this.invoiceForm.items.unshift({
                id: null,
                name: '',
                error: false
            });

            // the modal body scrolls now: bring the new (first) item into view
            this.$nextTick(() => {
                this.$refs.itemList?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        },

        removeItem(index) {
            this.$dialog.show({
                title: "Delete Item",
                text: 'Are you sure you want to delete this item?',
                onConfirm: () => {
                    this.invoiceForm.items.splice(index, 1);
                },
            });
        },

        async saveInvoice() {
            this.invoiceForm["source"] = 'manual'
            const success = await this.addInvoiceItem(this.invoiceForm);
            if (success) {
                this.hide();
                this.$emit('success');
            }
        }
    }
}
</script>